import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userInfo, setUserInfo] = useState({
        CustomerType: null,
        Ledcode: null,
        LedName: null,
        AgentCode: null,
    });
    const [loading, setLoading] = useState(true);

    // Only one effect to hydrate from localStorage
    useEffect(() => {
        const CustomerType = localStorage.getItem("CustomerType");
        const Ledcode = localStorage.getItem("Ledcode");
        const LedName = localStorage.getItem("LedName");
        const AgentCode = localStorage.getItem("AgentCode");

        if (CustomerType && Ledcode && LedName) {
            setIsLoggedIn(true);
            setUserInfo({ CustomerType, Ledcode, LedName, AgentCode });
        }

        setLoading(false);
    }, []);

    const login = (userData) => {
        localStorage.setItem("CustomerType", userData.CustomerType);
        localStorage.setItem("Ledcode", userData.Ledcode);
        localStorage.setItem("LedName", userData.LedName);
        localStorage.setItem("AgentCode", userData.AgentCode);
        setUserInfo(userData);
        setIsLoggedIn(true);
    };

    const logout = () => {
        localStorage.removeItem("CustomerType");
        localStorage.removeItem("Ledcode");
        localStorage.removeItem("LedName");
        localStorage.removeItem("AgentCode");
        setUserInfo({
            CustomerType: null,
            Ledcode: null,
            LedName: null,
            AgentCode: null,
        });
        setIsLoggedIn(false);
    };

    return (
        <AuthContext.Provider value={{ isLoggedIn, userInfo, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
